import { Enum } from './Enum';

export class EmployeeLicenseWarning extends Enum {
  translationKey = 'employeeLicenseWarning';

  static readonly asArray: EmployeeLicenseWarning[] = [];

  static readonly byKey: { [name: string]: EmployeeLicenseWarning } = {};

  static readonly D30 = new EmployeeLicenseWarning('D30');

  static readonly D60 = new EmployeeLicenseWarning('D60');

  static readonly D90 = new EmployeeLicenseWarning('D90');

  constructor(public readonly value: string) {
    super();
    EmployeeLicenseWarning.asArray.push(this);
    EmployeeLicenseWarning.byKey[value] = this;
  }

  static sortType(a?: EmployeeLicenseWarning, b?: EmployeeLicenseWarning) {
    return a?.value?.localeCompare(b?.value || '') || 0;
  }

  static getColor(item: EmployeeLicenseWarning) {
    if (item === EmployeeLicenseWarning.D30) return 'error';
    if (item === EmployeeLicenseWarning.D60) return 'warning';
    if (item === EmployeeLicenseWarning.D90) return 'success';
    return 'action';
  }
}

export default EmployeeLicenseWarning;
